import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { KeyRound, UserPlus, Check } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { UserAvatar } from "@/components/UserBits";

export function VaultFriends({ onGift }) {
  const [d, setD] = useState(null);
  const load = () => api.get("/vault/friends").then(({ data }) => setD(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const gift = async (f) => {
    try { await api.post(`/vault/gift/${f.user_id}`); toast.success(`Schlüssel an ${f.name} verschenkt – du bekommst einen Danke-Schlüssel 🔑`); onGift(); load(); }
    catch (e) { toast.error(formatErr(e)); }
  };
  if (!d) return null;
  return (
    <div className="rounded-3xl bg-slate-900 text-white p-5 space-y-3 ring-1 ring-white/10" data-testid="vault-friends">
      <div>
        <h3 className="font-display text-lg font-extrabold flex items-center gap-2"><KeyRound className="w-5 h-5 text-amber-300" /> Schlüssel verschenken</h3>
        <p className="text-sm text-white/60">1× am Tag: Schenk einem Freund einen Extra-Schlüssel – und du bekommst selbst einen Danke-Schlüssel dazu. Jeder neue Freund, den du einlädst, bringt dir heute ebenfalls einen Schlüssel (max. 2).</p>
      </div>
      {d.friends.length === 0 ? (
        <Link to="/einladen" className="inline-flex items-center gap-2 h-11 px-5 rounded-full bg-amber-400 text-slate-900 font-extrabold" data-testid="vault-invite-btn"><UserPlus className="w-4 h-4" /> Freunde einladen</Link>
      ) : (
        <ul className="flex gap-3 overflow-x-auto pb-1 -mx-1 px-1">
          {d.friends.map((f) => {
            const given = d.gave_to === f.user_id;
            return (
              <li key={f.user_id} className="shrink-0 w-24 text-center space-y-1.5">
                <UserAvatar userId={f.user_id} name={f.name} picture={f.picture} size="w-14 h-14 mx-auto" text="text-lg" />
                <p className="text-xs font-bold truncate">{f.name}</p>
                <button onClick={() => gift(f)} disabled={!!d.gave_to || f.full} data-testid={`vault-gift-${f.user_id}`}
                  className="w-full h-8 rounded-full text-xs font-extrabold bg-amber-400 text-slate-900 disabled:bg-white/10 disabled:text-white/40 inline-flex items-center justify-center gap-1">
                  {given ? <><Check className="w-3.5 h-3.5" /> Geschenkt</> : f.full ? "Voll" : <><KeyRound className="w-3.5 h-3.5" /> Schenken</>}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
